import { Link, useLocation } from "@tanstack/react-router";

function HomeIcon({ active }: { active: boolean }) {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill={active ? "currentColor" : "none"}
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <title>Home</title>
      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
      <polyline points="9 22 9 12 15 12 15 22" />
    </svg>
  );
}

function SettingsIcon({ active }: { active: boolean }) {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill={active ? "currentColor" : "none"}
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <title>Settings</title>
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
    </svg>
  );
}

const tabs = [
  {
    path: "/dashboard",
    label: "Home",
    icon: HomeIcon,
    pattern: /^\/(dashboard|competition|join|friends)/,
  },
  { path: "/settings", label: "Settings", icon: SettingsIcon, pattern: /^\/(settings|org)/ },
];

export default function BottomNav() {
  const location = useLocation();

  function isActive(tab: (typeof tabs)[number]) {
    if (tab.pattern.test(location.pathname)) return true;
    if (tab === tabs[0] && !tabs.some((t) => t.pattern.test(location.pathname))) return true;
    return false;
  }

  return (
    <nav
      aria-label="Main navigation"
      className="fixed bottom-0 left-0 right-0 z-50 bg-card border-t border-[rgba(28,27,46,0.1)] shadow-[0_-1px_0_0_rgba(28,27,46,0.05)]"
    >
      <div className="flex items-center justify-around max-w-lg mx-auto h-14 px-2">
        {tabs.map((tab) => {
          const active = isActive(tab);
          return (
            <Link
              key={tab.label}
              to={tab.path}
              className={`flex flex-col items-center justify-center gap-0.5 py-1 px-3 no-underline rounded-xl min-w-0 transition-colors ${
                active ? "text-aqua" : "text-text-dim"
              }`}
            >
              <tab.icon active={active} />
              <span
                className={`text-[0.625rem] font-bold leading-none ${
                  active ? "text-aqua" : "text-text-dim"
                }`}
              >
                {tab.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
